import { render } from "./app-logo-powered-by-swipe-dark.vue?vue&type=template&id=145d5123"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-powered-by-swipe-dark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "145d5123"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('145d5123', __exports__)) {
    console.log('reload')
    api.reload('145d5123', __exports__)
  }
  
  module.hot.accept("./app-logo-powered-by-swipe-dark.vue?vue&type=template&id=145d5123", () => {
    console.log('re-render')
    api.rerender('145d5123', render)
  })

}


export default __exports__